module.exports = __webpack_public_path__ + "static/media/workSession.8e287e2f.svg";